export const loadKey = {
    animating: 'animating',
    default: 'default',
    loadingHeader: 'loadingHeader',
    loadingPage: 'loadingPage',
    loadingTab: 'loadingTab',
    pageLock: 'pageLock',
    screenLock: 'screenLock',
    showHiding: 'showing',
    sliding: 'sliding',
} as const;

export type LoadKey = typeof loadKey[keyof typeof loadKey];
